/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Saisissez au moins {minimumLength} caractères ou chiffres pour chercher les enregistrements {sourceName}.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Aucun résultat',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Vérifiez les résultats d’autres sources ou modifiez votre mot clé.',
  [HintsType.searching]: 'Recherche…',
  companyTabTitle: 'Entreprise',
  personalTabTitle: 'Personnel',
  direct: 'Direct',
  extension: 'Ext.',
  contact: 'Contact',
  mobile: 'Mobile',
  company: 'Entreprise',
  home: 'Domicile',
  home2: 'Domicile',
  other: 'Autre',
  business: 'Professionnel',
  business2: 'Professionnel',
  car: 'Véhicule',
  fax: 'Fax',
  assistant: 'Assistant',
  callback: 'Rappel',
  MobileNumber: 'Numéro de mobile',
  ContactNumber: 'Numéro de téléphone',
  DirectNumber: 'Numéro direct',
  doNotCall: 'Ne pas appeler',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
